import * as React from 'react';
import {
  Box,
  Popper,
  List,
  ListItemButton,
  ListItemText,
  ClickAwayListener,
} from '@mui/material';
import { useAuth } from '../../AuthProvider';
import text from '../../lib/dictionary.json';

export default function SideNavCard({
  anchorEl,
  items,
  open,
  onItemClick,
  onClose,
}) {
  const { lang } = useAuth();

  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement={lang === 'en' ? 'right' : 'left'}
      modifiers={[
        {
          name: 'offset',
          options: {
            offset: [0, 10],
          },
        },
      ]}
      sx={{ zIndex: 1300 }}
    >
      <ClickAwayListener onClickAway={onClose}>
        <Box
          sx={{
            position: 'relative',
            bgcolor: 'rgb(55, 65, 81)',
            borderRadius: 2,
            minWidth: 220,
            boxShadow: '0 10px 30px rgba(0,0,0,0.35)',
            overflow: 'hidden',

            /* Arrow */
            '&::before': {
              content: '""',
              position: 'absolute',
              left: -8,
              top: 20,
              width: 0,
              height: 0,
              borderTop: '8px solid transparent',
              borderBottom: '8px solid transparent',
              borderRight: '8px solid rgb(55, 65, 81)',
            },
          }}
        >
          <List disablePadding>
            {items.map((item, index) => (
              <Box key={index}>
                <ListItemButton
                  sx={{
                    px: 2,
                    py: 1.1,
                    color: '#fff'
                  }} onClick={() => {
                    onClose();
                    onItemClick?.(item);
                  }}>
                  <ListItemText
                    primary={text[lang][item.title]}
                    primaryTypographyProps={{
                      fontSize: 14,
                      fontWeight: 500,
                    }}
                  />
                </ListItemButton>

                {index < items.length - 1 && (
                  <div className='separator' style={{
                    height: 1,
                    '--app-gradient-1': 'rgba(91, 140, 203, .4)',
                    '--app-separator': 'rgba(91, 140, 203, .8)',
                  }}></div>
                )}
              </Box>
            ))}
          </List>
        </Box>
      </ClickAwayListener>
    </Popper>
  );
}
